// The mascot's place on the reveal and the podium: a reserved, fixed-size box so a character chosen later can take it
// without anything around it moving. Until then the Pulse stands in, in the mood of the moment, and nothing else.
//
//   right   spike (a burst and sparks)       wrong   jolt (the defib shock)
//   partial steady (neither a win nor a miss) none    flat (the soft flatline)
//   podium  crown
//
// The box is `size` × `size` px (square: the most neutral frame for whatever character arrives). The Pulse paints
// across its width and may spark above it, so the box never clips. Decorative unless `label` is given.
import { Pulse, type PulseMood } from './Pulse';

export type MascotMoment = 'right' | 'wrong' | 'partial' | 'none' | 'podium';

export const MASCOT_MOOD: Readonly<Record<MascotMoment, PulseMood>> = { right: 'spike', wrong: 'jolt', partial: 'steady', none: 'flat', podium: 'crown' };
const TONE: Readonly<Record<MascotMoment, string>> = { right: 'text-correct', wrong: 'text-wrong', partial: 'text-cart', none: 'text-ink-3', podium: 'text-cart' };

export function MascotSlot({ moment, size = 64, className = '', label }: { moment: MascotMoment; size?: number; className?: string; label?: string }) {
  const a11y = label ? {} : { 'aria-hidden': true as const };
  return (
    <span data-part="mascot-slot" data-moment={moment} {...a11y}
      className={`relative inline-flex shrink-0 items-center justify-center ${TONE[moment]} ${className}`}
      style={{ width: size, height: size, overflow: 'visible' }}>
      <Pulse mood={MASCOT_MOOD[moment]} width={size} height={Math.round(size * 0.42)} glow={moment === 'right' || moment === 'podium'} label={label} />
    </span>
  );
}
